import { IStripeStatusResponse } from 'interfaces/stripe';

export function isStripeSetupComplete(
  status: IStripeStatusResponse | undefined
) {
  if (!status) return false;

  return status.chargesEnabled && status.payoutsEnabled && status.accountId;
}
